import React from "react";
import HeroSection from "../components/HeroSection";
import icons from "../constants/icons.ts";
import { heroSections } from "../constants/data.ts";

const Privacy = () => {
  return (
    <main className="bg-background">
      <HeroSection {...heroSections.privacy} />

       {/* Effective date */}
      <section className="py-16 md:py-24 px-outer">
        <div className="container mx-auto max-w-3xl">
          <h2 className="heading-main text-center mb-12">
            Effective Date: 27/01/2022
          </h2>

          <div className="space-y-6">
            <div className="flex gap-4">
              <i className={`${icons.actions.checkCircle} text-2xl text-primary flex-shrink-0 mt-1`}></i>
              <div>
                <h3 className="heading mb-2">Introduction</h3>
                <p className="text-body">
                  Westlisoft Technologies Pvt Ltd is committed to protecting the privacy and security of your personal information. This Privacy Policy outlines our practices concerning the collection, use, and disclosure of personal data when you visit our website or use our services. By accessing or using our website and services, you consent to the practices described in this policy.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <i className={`${icons.actions.checkCircle} text-2xl text-primary flex-shrink-0 mt-1`}></i>
              <div>
                <h3 className="heading mb-2">Information We Collect</h3>
                <p className="text-body">
                  We may collect and process the following categories of personal information:
                </p>
                <h3 className="text-primary">Information You Provide</h3>
                <ul className="list-disc list-inside text-body">
                  <li>Name</li>
                  <li>Contact information (email address, phone number, postal address)</li>
                  <li>Company information</li>
                  <li>User-generated content (e.g., comments, messages)</li>
                </ul>
                <h3 className="text-primary">Automatically Collected Information</h3>
                <ul className="list-disc list-inside text-body">
                  <li>IP address</li>
                  <li>Browser information</li>
                  <li>Device information</li>
                  <li>Usage data (e.g., pages visited, time spent on our website)</li>
                </ul>
              </div>
            </div>

            <div className="flex gap-4">
              <i className={`${icons.actions.checkCircle} text-2xl text-primary flex-shrink-0 mt-1`}></i>
              <div>
                <h3 className="heading mb-2">How We Use Your Information</h3>
                <p className="text-body">
                  We use your personal information for the following purposes:
                </p>
                  <ul className="list-disc list-inside text-body">
                    <li>Provide and improve our services</li>
                    <li>Respond to your inquiries and requests</li>
                    <li>Send promotional and marketing materials</li>
                    <li>Monitor and analyze website usage</li>
                    <li>Comply with legal obligations</li>
                  </ul>
              </div>
            </div>

            <div className="flex gap-4">
              <i className={`${icons.actions.checkCircle} text-2xl text-primary flex-shrink-0 mt-1`}></i>
              <div>
                <h3 className="heading mb-2">Cookies and Tracking Technologies</h3>
                <p className="text-body">
                  We use cookies and similar tracking technologies to enhance your experience on our website and collect usage data. You can manage your cookie preferences through your browser settings.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <i className={`${icons.actions.checkCircle} text-2xl text-primary flex-shrink-0 mt-1`}></i>
              <div>
                <h3 className="heading mb-2">Sharing Your Information</h3>
                <p className="text-body">
                  We may share your personal information with:
                </p>
                <ul className="list-disc list-inside text-body">
                  <li>Our affiliates and subsidiaries</li>
                  <li>Service providers</li>
                  <li>Legal authorities when required by law</li>
                </ul>
              </div>
            </div>

            <div className="flex gap-4">
              <i className={`${icons.actions.checkCircle} text-2xl text-primary flex-shrink-0 mt-1`}></i>
              <div>
                <h3 className="heading mb-2">Security</h3>
                <p className="text-body">
                  We implement appropriate security measures to protect your personal information from unauthorized access, disclosure, alteration, and destruction.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <i className={`${icons.actions.checkCircle} text-2xl text-primary flex-shrink-0 mt-1`}></i>
              <div>
                <h3 className="heading mb-2">Your Choices and Rights</h3>
                <p className="text-body">
                  You have the right to access, correct, or delete your personal information. You can also opt out of marketing communications. For these requests or any privacy-related inquiries, please contact us at info@westlisoft.com.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <i className={`${icons.actions.checkCircle} text-2xl text-primary flex-shrink-0 mt-1`}></i>
              <div>
                <h3 className="heading mb-2">Third-Party Links</h3>
                <p className="text-body">
                  Our website may contain links to third-party websites. We are not responsible for the privacy practices of those websites, and this Privacy Policy does not apply to them.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <i className={`${icons.actions.checkCircle} text-2xl text-primary flex-shrink-0 mt-1`}></i>
              <div>
                <h3 className="heading mb-2">Changes to this Policy</h3>
                <p className="text-body">
                  We may update this Privacy Policy to reflect changes in our practices. We will notify you of any material changes by posting the updated policy on our website.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <i className={`${icons.actions.checkCircle} text-2xl text-primary flex-shrink-0 mt-1`}></i>
              <div>
                <h3 className="heading mb-2">Contact Us</h3>
                <p className="text-body">
                  If you have any questions or concerns about this Website Disclaimer, please contact us at info@westlisoft.com.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>
    </main>
  );
};

export default Privacy;
